import { Link } from 'react-router'
import { ExternalLink } from 'lucide-react'
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/shadcn/card'

export function AccountTermsPage() {
  return (
    <Card className="flex-1 space-y-4 p-3 sm:p-5">
      <CardHeader className="flex flex-col">
        <CardTitle className="text-xl font-bold sm:text-2xl">Legal Documents</CardTitle>
        <CardDescription className="text-muted-foreground text-sm sm:text-base">
          Review our terms of service and privacy policy
        </CardDescription>
      </CardHeader>

      <CardContent className="space-y-4">
        <Link
          to="/terms-of-service"
          target="_blank"
          className="bg-card hover:bg-hover border-border flex items-center justify-between rounded-lg border p-4 transition-colors">
          <div>
            <h3 className="text-foreground font-medium">Terms of Service</h3>
            <p className="text-muted-foreground text-sm">
              Read our terms and conditions for using CASSI
            </p>
          </div>
          <ExternalLink className="text-muted-foreground h-5 w-5" />
        </Link>

        <Link
          to="/privacy"
          target="_blank"
          className="bg-card hover:bg-hover border-border flex items-center justify-between rounded-lg border p-4 transition-colors">
          <div>
            <h3 className="text-foreground font-medium">Privacy Policy</h3>
            <p className="text-muted-foreground text-sm">
              Learn how we collect, use, and protect your data
            </p>
          </div>
          <ExternalLink className="text-muted-foreground h-5 w-5" />
        </Link>

        <p className="text-muted-foreground pt-4 text-xs">Last updated: January 19, 2026</p>
      </CardContent>
    </Card>
  )
}
